/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdf_Cv_Review_Summary_SectionInputs */

const en_pdf_cv_review_summary_section = /** @type {(inputs: Pdf_Cv_Review_Summary_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary`)
};

const de_pdf_cv_review_summary_section = /** @type {(inputs: Pdf_Cv_Review_Summary_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenfassung`)
};

/**
* | output |
* | --- |
* | "Summary" |
*
* @param {Pdf_Cv_Review_Summary_SectionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pdf_cv_review_summary_section = /** @type {((inputs?: Pdf_Cv_Review_Summary_SectionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdf_Cv_Review_Summary_SectionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pdf_cv_review_summary_section(inputs)
	return en_pdf_cv_review_summary_section(inputs)
});